<template>
    <div>
        <el-form ref="prechargeMgtForm" :inline="true" :model="prechargeMgtForm" @submit.native.prevent>
            <el-form-item label="SIM卡状态：">
                <el-select>
                    <el-option></el-option>
                    <el-option></el-option>
                    <el-option></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="类型：">
                <el-select>
                    <el-option>全部</el-option>
                    <el-option>剩余流量不足</el-option>
                    <el-option>没有过期时间</el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="过期状态：">
                <el-select>
                    <el-option>全部</el-option>
                    <el-option>将要过期</el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="供应商：">
                <el-select>
                    <el-option>111111</el-option>
                    <el-option>222222</el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary">搜索查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="success">批量导出</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tableData" border  height="628px">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column prop="name" label="ICCID "></el-table-column>
            <el-table-column prop="chargemoney" label="接入号"></el-table-column>
            <el-table-column prop="lastmoney" label="套餐名称"></el-table-column>
            <el-table-column prop="xfmoney" label="供应商"></el-table-column>
            <el-table-column prop="create" label="总流量(GB)"></el-table-column>
            <el-table-column prop="time" label="剩余流量(GB)"></el-table-column>
            <el-table-column label="已用流量(GB)"></el-table-column>
            <el-table-column label="过期时间"></el-table-column>
            <el-table-column label="SIM卡状态"></el-table-column>
            <el-table-column label="时间"></el-table-column>
        </el-table>
        
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[100, 200, 300, 400]"
            :page-size="100"
            layout="total, sizes, prev, pager, next, jumper"
            :total="400">
        </el-pagination>
    </div>
</template>

<script>

export default {
    data(){
        return {
            prechargeMgtForm: {
                agentName: ''
            },
            tableData: [],
            currentPage: 1
        }
    },
    methods: {
        handleSizeChange(){

        },
        handleCurrentChange(val){
            this.currentPage = val
        }
    },
    created(){
    }
}
</script>

<style lang="less" scoped>

</style>

